import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.saju');
import { DeploymentCheck } from "src/libs/portal/saju/deployment";
import { ReadingSession } from "src/libs/portal/saju/reading-history";
import { PwaSession } from "src/libs/portal/saju/pwa";
import { QuestionSession } from "src/libs/portal/saju/questions";
import { RunSession, runPresentation, RUN_STATES, PROGRESS_STATES, taskMessage, readingBlocks } from "src/libs/portal/saju/runs";
import { ReportReader, readingReference, tableBlock } from "src/libs/portal/saju/report-reader";
import { ChangeDetectorRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";
import { UploadSession, IMAGE_ROLES } from "src/libs/portal/saju/uploads";
import { IntakeSession, POSITIONS, LABELS, STEMS, BRANCHES, GANZHI } from "src/libs/portal/saju/intake";
import { Feature, EMPTY_FEATURE, FeatureInputs, loadFeatures } from "src/libs/portal/saju/features";
import { DEMO_PROFILES, ExplorationSession } from "src/libs/portal/saju/exploration";
import { AccessSession } from "src/libs/portal/saju/access";
import { PhotoQuestionSession } from "src/libs/portal/saju/photo-questions";

const PUBLIC_FEATURES: Record<string, { name: string; summary: string }> = {
    F1: {
        name: '나의 캐릭터 풀이',
        summary: '관계·연애·일·돈에서 드러나는 내 모습을 12개의 캐릭터 챕터로 읽어요.'
    },
    F2: {
        name: '자세한 사주 풀이',
        summary: '타고난 모습부터 돈·일·관계와 삶의 흐름까지 긴 보고서로 깊게 읽어요.'
    },
    F3: {
        name: '두 관점으로 보는 나',
        summary: '같은 나를 현실적인 시선과 신중한 시선으로 따로 읽고 차이를 한눈에 비교해요.'
    }
};

@Component({
    selector: 'wiz-page-saju',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.saju/view.scss */
:host {
  display: block;
  min-height: 100vh;
  color: #222a35;
  background: #f6f7f8;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 1rem;
  line-height: 1.7;
  --space: 1.5rem;
  --border: #d7dce2;
  --muted: #535e6c;
}

*, *::before, *::after {
  box-sizing: border-box;
}

a {
  color: inherit;
  text-underline-offset: 0.22em;
}

button, select {
  font: inherit;
}

button, a, select, summary {
  -webkit-tap-highlight-color: transparent;
}

:is(a, button, select, summary):focus-visible {
  outline: 3px solid #245aa0;
  outline-offset: 4px;
}

h1:focus {
  outline: none;
}

h1:focus-visible {
  outline: 2px solid #245aa0;
  outline-offset: 5px;
}

h1, h2, h3, p {
  margin: 0 0 1rem;
  overflow-wrap: anywhere;
}

h1 {
  font-size: clamp(1.75rem, 3.5vw, 2.75rem);
  line-height: 1.3;
  letter-spacing: -0.04em;
}

h2 {
  font-size: 1.25rem;
  line-height: 1.5;
  letter-spacing: -0.025em;
}

h3 {
  font-size: 1rem;
}

small, .muted {
  color: var(--muted);
}

small {
  display: block;
  font-size: 0.8125rem;
}

.site-shell {
  max-width: 1160px;
  margin: auto;
  padding: 0 2rem;
}

.site-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 1.25rem 0;
}

.site-name {
  text-decoration: none;
  font-weight: 750;
  font-size: 1.2rem;
}

.header-tools {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-left: auto;
  min-width: 0;
}

.header-tools > a, .header-button, .account-menu > summary {
  min-height: 44px;
  padding: 0.55rem 0.35rem;
  font: inherit;
  cursor: pointer;
}

.header-button {
  border: 0;
  background: transparent;
  color: inherit;
}

.account-menu {
  position: relative;
  margin: 0;
  padding: 0;
  border: 0;
}

.account-content {
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 5;
  width: min(16rem, 100vw - 2rem);
  padding: 1rem;
  background: white;
  border: 1px solid var(--border);
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(34, 42, 53, 0.1019607843);
}

.account-content p {
  padding: 0;
  overflow-wrap: anywhere;
}

.account-recovery {
  margin-block: 1rem;
}

#service-help {
  max-width: 800px;
  margin: 0 0 1rem;
  border-top: 0;
}

nav {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem 1rem;
}

nav a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  min-height: 44px;
  padding: 0.35rem 0.15rem;
  text-decoration: none;
}

nav a[aria-current=page] {
  font-weight: 750;
  text-decoration: underline;
}

.preview-notice {
  display: flex;
  gap: 0.65rem 1rem;
  align-items: baseline;
  padding: 1rem 1.25rem;
  background: #e9edf1;
  border-radius: 0.5rem;
  font-size: 0.875rem;
}

.preview-notice strong {
  flex-shrink: 0;
}

.profile-strip {
  display: grid;
  grid-template-columns: 1fr minmax(220px, 290px);
  gap: var(--space);
  padding: var(--space) 0;
  border-bottom: 1px solid var(--border);
}

.profile-summary, .profile-control {
  min-width: 0;
}

.profile-summary strong {
  display: inline-block;
  margin-right: 0.75rem;
}

.profile-summary p {
  font-size: 0.875rem;
  margin: 0.5rem 0 0;
  color: var(--muted);
}

.eyebrow {
  display: block;
  color: var(--muted);
  font-size: 0.8125rem;
  font-weight: 650;
  margin-bottom: 0.5rem;
}

label {
  display: block;
  font-weight: 650;
  margin-bottom: 0.4rem;
  font-size: 0.875rem;
}

select {
  width: 100%;
  min-height: 44px;
  padding: 0.55rem 0.75rem;
  border: 1px solid #8793a2;
  border-radius: 0.4rem;
  background: white;
  color: inherit;
}

.profile-control small {
  margin-top: 0.4rem;
}

main {
  padding: 2.75rem 0 3rem;
}

.page-heading {
  max-width: 850px;
}

.lead {
  max-width: 760px;
  color: var(--muted);
  font-size: 1.0625rem;
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin: 1.25rem 0;
}

.actions.vertical {
  flex-direction: column;
  align-items: flex-start;
}

.button {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  min-height: 44px;
  max-width: 100%;
  border: 1px solid #8793a2;
  border-radius: 0.4rem;
  padding: 0.65rem 1rem;
  background: white;
  text-decoration: none;
  font-weight: 650;
  line-height: 1.5;
  cursor: pointer;
  text-align: center;
  overflow-wrap: anywhere;
}

.button:hover {
  background: #edf0f4;
}

.button.primary {
  background: #303d4d;
  border-color: #303d4d;
  color: white;
}

.button.primary:hover {
  background: #1e2938;
}

.feature-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--space);
  margin: 2rem 0;
}

.feature-card, .panel {
  min-width: 0;
  padding: var(--space);
  border: 1px solid var(--border);
  border-radius: 0.65rem;
  background: white;
}

.feature-card {
  display: flex;
  flex-direction: column;
}

.feature-card > .button {
  margin-top: auto;
}

.feature-detail {
  display: inline-flex;
  align-self: flex-start;
  min-height: 44px;
  align-items: center;
  margin-top: 0.55rem;
  font-weight: 650;
}

.start-options {
  margin-top: -0.5rem;
}

.card-top {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
}

.feature-id {
  font-size: 1.2rem;
  font-weight: 750;
}

.badge {
  display: inline-block;
  padding: 0.2rem 0.6rem;
  background: #e9edf1;
  border: 1px solid #d2d9e1;
  border-radius: 0.3rem;
  font-size: 0.75rem;
  font-weight: 650;
  color: #424e5e;
}

.badge.available {
  background: #edf3f8;
  border-color: #bdcddf;
  color: #2b5278;
}

.format {
  font-size: 0.875rem;
  font-weight: 650;
}

.feature-card p:not(.format) {
  color: var(--muted);
}

.two-column {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space);
  margin: var(--space) 0;
}

.panel > .badge {
  margin-bottom: 1rem;
}

.panel > :last-child {
  margin-bottom: 0;
}

.reading-width {
  max-width: 800px;
}

.steps {
  padding-left: 1.4rem;
}

.steps li {
  padding-left: 0.25rem;
  margin-bottom: 0.85rem;
}

.steps p {
  color: var(--muted);
  margin-top: 0.35rem;
}

details {
  border-top: 1px solid var(--border);
  margin-top: 1rem;
  padding-top: 0.5rem;
}

summary {
  cursor: pointer;
  padding: 0.65rem 0;
  min-height: 44px;
  font-weight: 650;
}

details p {
  padding-top: 0.75rem;
}

.chapter-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.65rem 2rem;
  padding-left: 1.5rem;
}

.perspectives section {
  padding: 1rem;
  background: #f6f7f8;
  border-radius: 0.4rem;
}

.perspectives ul {
  padding-left: 1.25rem;
}

.status-list {
  margin: 1.5rem 0;
}

.status-list div {
  display: grid;
  grid-template-columns: 100px 1fr;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid var(--border);
}

dt {
  font-weight: 650;
}

dd {
  margin: 0;
  overflow-wrap: anywhere;
}

.empty-state {
  max-width: 800px;
  padding: 2rem;
}

.context-note, .storage-notice {
  padding: 0.75rem;
  background: #e9edf1;
}

footer {
  border-top: 1px solid var(--border);
  padding: 1.5rem 0;
  color: var(--muted);
  font-size: 0.8125rem;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.skip-link {
  position: fixed;
  top: 0.5rem;
  left: 1rem;
  transform: translateY(-180%);
  z-index: 10;
  background: white;
  padding: 0.75rem 1rem;
  border: 2px solid #245aa0;
}

.skip-link:focus {
  transform: none;
}

@media (max-width: 850px) {
  .feature-grid {
    grid-template-columns: 1fr;
  }
  .site-header {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 0.3rem 0.75rem;
  }
  .site-header nav {
    grid-column: 1/-1;
    grid-row: 2;
  }
  .header-tools {
    grid-column: 2;
    grid-row: 1;
  }
  .feature-card > .button {
    align-self: flex-start;
  }
}
@media (max-width: 600px) {
  :host {
    --space: 1rem;
  }
  .site-shell {
    padding: 0 1rem;
  }
  .preview-notice {
    flex-direction: column;
    gap: 0.25rem;
    padding: 1rem;
  }
  .profile-strip, .two-column, .chapter-list {
    grid-template-columns: 1fr;
  }
  main {
    padding-top: 2rem;
  }
  nav {
    column-gap: 0.9rem;
    font-size: 0.875rem;
  }
  .actions > .button {
    width: 100%;
  }
  .actions.vertical {
    align-items: stretch;
  }
  .empty-state {
    padding: 1.25rem;
  }
  .status-list div {
    grid-template-columns: 1fr;
    gap: 0.3rem;
  }
}
input, textarea {
  font: inherit;
  color: inherit;
  width: 100%;
  min-height: 44px;
  border: 1px solid #8793a2;
  border-radius: 0.4rem;
  padding: 0.55rem 0.75rem;
  background: white;
}

textarea {
  resize: vertical;
}

:is(input, textarea):focus-visible {
  outline: 3px solid #245aa0;
  outline-offset: 3px;
}

fieldset {
  border: 0;
  margin: 0;
  padding: 0;
  min-width: 0;
}

legend {
  font-weight: 700;
  margin-bottom: 1rem;
}

input + label, textarea + label {
  margin-top: 1rem;
}

:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.auth-panel {
  margin-top: 1rem;
}

.raw-text {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font: inherit;
  background: #f6f7f8;
  padding: 0.75rem;
}

.capture-guide {
  margin: 1rem 0;
}

.capture-guide-screen {
  max-width: 34rem;
  padding: 1rem;
  border: 2px solid #5d6c78;
  border-radius: 0.65rem;
  background: #f8fafb;
  box-shadow: inset 0 0 0 4px white;
}

.capture-guide-title {
  font-weight: 750;
  margin-bottom: 0.75rem;
  color: #334155;
}

.capture-guide-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border: 1px solid #9aa8b4;
}

.capture-guide-grid div {
  display: grid;
  gap: 0.35rem;
  padding: 0.65rem 0.4rem;
  text-align: center;
  border-right: 1px solid #9aa8b4;
}

.capture-guide-grid div:last-child {
  border-right: 0;
}

.capture-guide-grid span {
  font-size: 1.25rem;
  font-weight: 750;
}

.capture-guide-luck {
  margin-top: 0.7rem;
  padding: 0.55rem;
  border: 1px dashed #7c8d9a;
  text-align: center;
  font-size: 0.85rem;
}

.capture-guide figcaption {
  margin-top: 0.5rem;
  color: #46535f;
}

.privacy-note {
  padding: 0.75rem 1rem;
  border-left: 4px solid #52697f;
  background: #f3f6f8;
}

.check-line {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-height: 44px;
  margin: 1rem 0;
  cursor: pointer;
}

.check-line input {
  width: 24px;
  height: 24px;
  min-height: 24px;
  flex-shrink: 0;
}

.error {
  color: #9e2222;
}

.pillar-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  margin: 1rem 0;
}

.pillar-table caption {
  text-align: left;
  font-weight: 700;
  margin-bottom: 1rem;
}

.pillar-table th, .pillar-table td {
  padding: 0.75rem;
  text-align: left;
  border: 1px solid var(--border);
  vertical-align: top;
  overflow-wrap: anywhere;
}

.pillar-table th:first-child {
  width: 65px;
}

.stem-branch {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

.text-candidate-summary, .review-text-fallback {
  margin: 1rem 0;
  padding: 1rem;
  border: 1px solid #b8c5cf;
  border-radius: 0.5rem;
  background: #f8fafb;
}

.text-candidate-summary article {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  border-top: 1px solid #d8e0e6;
}

.text-candidate-summary article:first-of-type {
  border-top: 0;
}

.text-candidate-summary article .check-line {
  margin-left: auto;
}

.text-candidate-list {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.5rem;
  padding: 0;
  list-style: none;
}

.text-candidate-list li {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.65rem;
  border: 1px solid #ccd5dc;
  background: white;
}

.text-candidate-list span {
  font-size: 1.15rem;
}

.direct-entry {
  margin-top: 1rem;
}

.direct-entry > summary {
  font-weight: 700;
  cursor: pointer;
  min-height: 44px;
  padding: 0.65rem 0;
}

.saved-item {
  padding: 1rem 0;
  border-top: 1px solid var(--border);
}

@media (max-width: 850px) {
  .pillar-table, .pillar-table tbody, .pillar-table tr, .pillar-table th, .pillar-table td {
    display: block;
    width: 100%;
  }
  .pillar-table thead {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    clip-path: inset(50%);
  }
  .pillar-table th:first-child {
    width: 100%;
    background: #edf0f4;
  }
  .pillar-table tr {
    margin-bottom: 1rem;
  }
  .pillar-table caption {
    display: block;
  }
}
@media (max-width: 600px) {
  .capture-guide-grid, .text-candidate-list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .capture-guide-grid div:nth-child(2) {
    border-right: 0;
  }
  .capture-guide-grid div:nth-child(-n+2) {
    border-bottom: 1px solid #9aa8b4;
  }
  .text-candidate-summary article {
    display: block;
    padding-block: 0.5rem;
  }
  .text-candidate-summary article .check-line {
    margin-left: 0;
  }
}
.upload-panel {
  margin-bottom: 1.5rem;
}

.upload-privacy {
  padding: 0.75rem 1rem;
  border-left: 4px solid #52697f;
  background: #f3f6f8;
}

.attachment-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 0.75rem;
}

.attachment {
  min-width: 0;
  border: 1px solid var(--border);
  border-radius: 0.4rem;
  padding: 1rem;
}

.attachment h3 {
  overflow-wrap: anywhere;
}

.upload-progress {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 0.75rem;
  margin: 0.75rem 0;
}

.upload-progress progress {
  width: 100%;
  min-height: 1rem;
}

.capture-preview {
  display: block;
  width: 100%;
  height: 200px;
  object-fit: contain;
  background: #f6f7f8;
}

.original-preview {
  max-height: 480px;
  overflow: auto;
  border: 1px solid var(--border);
}

.original-preview img {
  display: block;
  max-width: none;
}

.photo-entry main {
  padding-top: 1.5rem;
}

.photo-entry .page-heading h1 {
  font-size: clamp(1.5rem, 3vw, 2rem);
}

.photo-entry .upload-panel {
  max-width: 1050px;
}

.photo-entry-form {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 28rem), 1fr));
  gap: 2rem;
  align-items: start;
}

.photo-attachments {
  min-width: 0;
  container-type: inline-size;
}

.photo-start, .photo-entry .attachment > * {
  min-width: 0;
  overflow-wrap: anywhere;
}

@container (min-width: 34.75rem) {
  .attachment-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.photo-entry .upload-privacy {
  padding: 0;
  border: 0;
  background: none;
  font-size: 0.875rem;
}

.photo-entry .upload-privacy a {
  margin-left: 0.5rem;
}

.photo-entry #upload-policy {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
}

.photo-entry .photo-count {
  margin: 0.5rem 0;
  font-weight: 650;
}

.photo-list-jump {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  margin-bottom: 0.25rem;
}

.photo-entry .attachment-grid {
  align-items: start;
  margin: 1rem 0;
}

.photo-entry .attachment {
  padding: 0.75rem;
}

.photo-entry .attachment h3 {
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
}

.photo-entry .capture-preview {
  height: 100px;
  margin-bottom: 0.5rem;
}

.photo-entry .attachment .badge {
  margin: 0;
}

.photo-entry .attachment-actions {
  margin: 0.5rem 0 0;
  gap: 0.5rem;
}

.photo-entry .attachment-actions > .button {
  width: auto;
  flex: 1 1 5rem;
  min-width: 44px;
  padding: 0.45rem 0.7rem;
  margin: 0;
}

.photo-entry .attachment details {
  margin-top: 0.3rem;
  padding-top: 0;
}

.attachment-filename {
  overflow-wrap: anywhere;
  white-space: normal;
  padding-bottom: 0.5rem;
}

.photo-entry .original-preview {
  max-height: min(30rem, 60vh);
}

.photo-entry .original-help {
  font-size: 0.8125rem;
  margin-bottom: 0.5rem;
}

.replace-photo {
  position: relative;
}

.replace-photo:focus-within {
  outline: 3px solid #245aa0;
  outline-offset: 3px;
}

.replace-photo:has(input:disabled) {
  opacity: 0.65;
  cursor: not-allowed;
}

.visually-hidden-file {
  position: absolute;
  width: 1px;
  min-height: 0;
  height: 1px;
  padding: 0;
  clip-path: inset(50%);
  overflow: hidden;
}

.photo-start {
  margin-top: 1.25rem;
}

.photo-start #start-photo-run {
  width: 100%;
  min-height: 50px;
}

.secondary-photo-actions {
  align-items: center;
  gap: 0.5rem 1.25rem;
  margin: 0.5rem 0 0;
}

.secondary-photo-actions a {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  font-size: 0.875rem;
}

.photo-entry .secondary-photo-actions > .button {
  width: auto;
  font-size: 0.875rem;
  font-weight: 400;
  border: 0;
  padding: 0.4rem 0;
  text-decoration: underline;
}

.photo-entry .public-auth:has(#account-logout) {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem 1rem;
  padding: 0.5rem 1rem;
}

.photo-entry .public-auth:has(#account-logout) p {
  margin: 0;
  font-size: 0.875rem;
}

.photo-entry .public-auth #account-logout {
  margin-left: auto;
  padding: 0.4rem 0.7rem;
  font-size: 0.875rem;
}

.photo-help, .manual-input-tools {
  max-width: 850px;
}

.review-row {
  padding: 1rem 0;
  border-top: 1px solid #cbd5df;
  min-width: 0;
}

.review-row.needs-attention {
  border-left: 4px solid #9d772c;
  padding-left: 0.75rem;
  background: #fffcf5;
}

.photo-compare {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(110px, 1fr);
  gap: 1rem;
}

.photo-evidence, .read-candidates {
  min-width: 0;
}

.review-crop {
  overflow: auto;
  max-height: 320px;
  border: 1px solid var(--border);
  background: #f1f2f3;
}

.review-crop img {
  display: block;
  max-width: none;
  cursor: zoom-in;
}

.review-crop:focus-visible {
  outline: 3px solid #245aa0;
}

.read-pair {
  display: block;
  font-size: 2rem;
  line-height: 1.6;
}

.source-location {
  font-size: 0.8rem;
}

.review-requirements {
  padding: 1rem;
  background: #fffcf5;
  border: 1px solid #9d772c;
  margin: 1rem 0;
}

.review-panel input[type=range] {
  width: 100%;
  min-width: 0;
}

@media (max-width: 480px) {
  .photo-compare {
    grid-template-columns: minmax(0, 1fr) minmax(85px, 0.8fr);
    gap: 0.5rem;
  }
  .photo-compare .button {
    padding: 0.5rem;
    font-size: 0.875rem;
  }
}
.review-row table {
  width: 100%;
  table-layout: fixed;
}

.review-row td, .review-row th {
  overflow-wrap: anywhere;
}

.review-panel input[type=text] {
  max-width: 100%;
}

.review-panel .original-preview {
  max-width: 100%;
}

.timing-panel {
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #bec8d0;
}

.timing-group, .timing-section {
  margin: 16px 0;
  padding: 16px;
  border: 1px solid #c9d0d6;
  border-radius: 8px;
}

.timing-field {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 8px 16px;
  margin: 16px 0;
}

.timing-field input, .timing-field select {
  min-width: 0;
  width: 100%;
}

.timing-issues {
  overflow-wrap: anywhere;
}

@media (max-width: 600px) {
  .timing-field {
    grid-template-columns: minmax(0, 1fr);
  }
}
.run-status, .run-task {
  overflow-wrap: anywhere;
}

.run-actions {
  gap: 10px;
}

.run-actions > .button {
  min-width: 0;
  min-height: 44px;
  height: auto;
  flex-shrink: 0;
  white-space: normal;
}

#reading-state-detail:focus-visible {
  outline: 3px solid #245aa0;
  outline-offset: 4px;
}

@media (max-width: 420px) {
  .run-actions {
    flex-direction: column;
  }
  .run-actions > .button {
    width: 100%;
  }
}
.run-toc {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  margin-top: 1rem;
}

.run-task {
  scroll-margin-top: 1rem;
}

.reading-text {
  white-space: pre-wrap;
  line-height: 1.85;
}

.saved-reading + .saved-reading {
  border-top: 1px solid #bbb;
  margin-top: 2rem;
  padding-top: 1rem;
}

.connection {
  font-weight: 600;
}

.reading-summary {
  overflow-wrap: anywhere;
}

.summary-section {
  margin-top: 1.5rem;
}

.summary-table-wrap {
  overflow-x: auto;
}

.summary-table {
  width: 100%;
  min-width: 560px;
  border-collapse: collapse;
  table-layout: fixed;
}

.summary-table th, .summary-table td {
  border: 1px solid #bcc5cf;
  padding: 0.65rem;
  text-align: left;
  vertical-align: top;
}

.summary-table th:first-child {
  width: 22%;
}

.summary-table caption {
  text-align: left;
  padding: 0.6rem 0;
}

.summary-table p {
  margin: 0.4rem 0;
}

.reading-summary pre {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  font: inherit;
}

.run-chapter {
  margin: 1.5rem 0;
  overflow-anchor: none;
}

.run-chapter, .reader-item, .reader-paragraph, .summary-section {
  scroll-margin-top: 1.25rem;
}

.chapter-navigation {
  border-bottom: 1px solid var(--border);
  margin-bottom: 1rem;
}

.item-toc {
  display: grid;
  gap: 0.3rem;
  margin-bottom: 1.5rem;
}

.item-toc a {
  justify-content: flex-start;
  text-align: left;
}

.reader-provisional {
  padding: 1rem;
  background: #fff4dd;
  border-left: 4px solid #886116;
}

.chapter-body > summary {
  font-weight: 700;
  padding: 0.8rem 0;
}

.reader-item {
  padding: 1.5rem 0;
}

.reader-item h3 {
  font-size: 1.15rem;
}

.reader-paragraph {
  margin-bottom: 1.5rem;
}

.reader-evidence {
  padding: 1rem;
  background: #f3f6f8;
}

.reader-evidence summary {
  min-height: 44px;
}

.reader-version {
  overflow-wrap: anywhere;
}

[data-reader-anchor]:focus-visible {
  outline: 3px solid #245aa0;
  outline-offset: 3px;
}

@media (max-width: 600px) {
  .run-chapter {
    padding: 1rem;
  }
  .reader-item .reading-text {
    line-height: 1.95;
    word-break: normal;
    overflow-wrap: anywhere;
  }
}
.f1-reading, .f1-quality dd, .run-toc a {
  overflow-wrap: anywhere;
  min-width: 0;
}

.run-toc a strong, .run-toc a span {
  display: block;
}

.f1-quality {
  padding: 1rem;
  background: #f3f5f6;
  border-radius: 0.5rem;
}

.f1-quality dt {
  font-weight: 700;
  margin-top: 0.75rem;
}

.f1-quality dd {
  margin: 0.25rem 0 0.75rem;
}

.f1-disclosure {
  border-top: 1px solid #cbd2d8;
  padding: 0.75rem 0;
}

.f1-disclosure summary {
  cursor: pointer;
  padding: 0.5rem;
  line-height: 1.6;
}

.f1-disclosure summary:focus-visible, .f1-fact:focus {
  outline: 3px solid #355d7a;
  outline-offset: 3px;
}

.f1-fact {
  border-left: 3px solid #71889a;
  padding-left: 0.75rem;
  margin: 1rem 0;
}

.f1-fact-link {
  display: inline-block;
  padding: 0.5rem;
}

#linked-questions {
  scroll-margin-top: 1rem;
  margin-block: 1.5rem;
}

#linked-questions select, #linked-questions textarea {
  display: block;
  width: 100%;
  max-width: 100%;
  margin-block: 0.5rem 1rem;
}

.question-turn {
  border-top: 1px solid #ddd;
  margin-top: 1rem;
  padding-top: 1rem;
}

.question-location, .question-quote, .question-turn, .question-citation {
  overflow-wrap: anywhere;
}

.question-citation {
  display: block;
  margin-block: 0.5rem;
}

.library-filters {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  gap: 1rem;
  margin-block: 1rem;
}

.library-filters label {
  display: block;
}

.library-filters select, .library-filters input {
  width: 100%;
  min-width: 0;
}

.library-item, .delete-confirm {
  overflow-wrap: anywhere;
}

.saved-paragraphs {
  margin-block: 1.5rem;
}

.saved-paragraph {
  border-top: 1px solid #d3d8df;
  padding-block: 1rem;
  overflow-wrap: anywhere;
}

.saved-paragraph blockquote {
  margin: 0.75rem 0;
  padding-left: 1rem;
  border-left: 3px solid #66788b;
}

.save-paragraph {
  margin: 0.5rem 0.5rem 0.5rem 0;
}

.save-paragraph[aria-pressed=true] {
  background: #e4edf5;
}

.summary-card {
  margin: 1.5rem 0;
  padding: 1rem;
  border: 1px solid #bacdc5;
  border-radius: 12px;
  min-width: 0;
}
.summary-card p, .summary-card strong {
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}
.summary-card select, .summary-card textarea {
  display: block;
  width: 100%;
  max-width: 100%;
  margin: 0.5rem 0 1rem;
}
.summary-card .card-check {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  margin: 0.8rem 0;
}
.summary-card .card-check input {
  width: auto;
  flex: 0 0 auto;
}
.summary-card .card-source {
  padding: 1rem;
  background: #f3f7f5;
  margin: 1rem 0;
}
.summary-card .card-preview {
  display: block;
  width: 100%;
  max-width: 540px;
  height: auto;
  margin: 1rem auto;
}

:host {
  overflow-wrap: anywhere;
}

input, textarea, select, .actions > *, .stem-branch > * {
  min-width: 0;
  max-width: 100%;
}

input, textarea, select {
  font-size: max(1rem, 16px);
}

.button {
  white-space: normal;
}

.summary-table-wrap, .original-preview {
  max-width: 100%;
  overscroll-behavior-x: contain;
}

.summary-table-wrap:focus-visible, .original-preview:focus-visible {
  outline: 3px solid #245aa0;
  outline-offset: 3px;
}

input, textarea, select, button, summary {
  scroll-margin-block: 1.5rem;
}

#input-requirements {
  padding: 1rem;
  margin-block: 1rem;
  border-left: 4px solid #886116;
  background: #fff4dd;
}

#input-requirements a {
  display: inline-block;
  padding-block: 0.4rem;
}

@media (max-width: 600px) {
  .preview-notice strong {
    flex-shrink: 1;
  }
  .stem-branch {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .library-filters {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (prefers-reduced-motion: reduce) {
  :host, :host * {
    scroll-behavior: auto !important;
  }
}
:host .pwa-panel {
  margin: 1rem 0;
  padding: 0.75rem 1rem;
  border: 1px solid #c7d0d8;
  border-radius: 0.5rem;
  overflow-wrap: anywhere;
}

:host .pwa-panel summary {
  cursor: pointer;
  min-height: 2.75rem;
  align-content: center;
}

:host .pwa-panel p {
  margin: 0.5rem 0;
}

:host .offline-status {
  color: #704511;
  font-weight: 600;
}

#calculation-review .table-scroll {
  max-width: 100%;
  overflow-x: auto;
}

#calculation-review table {
  min-width: 36rem;
  width: 100%;
  border-collapse: collapse;
}

#calculation-review th, #calculation-review td {
  padding: 0.65rem;
  text-align: left;
  vertical-align: top;
  border-bottom: 1px solid #ddd;
}

.photo-question {
  margin: 1rem 0;
  padding: 1rem;
  border: 1px solid #c7d0d8;
  border-radius: 0.5rem;
}

.photo-question h4 {
  font-size: 1.1rem;
  line-height: 1.6;
  margin: 0 0 1rem;
}

.question-evidence {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.question-evidence figure {
  margin: 0;
  flex: 1 1 9rem;
  min-width: 0;
  max-width: 100%;
}

.question-evidence img {
  display: block;
  width: 100%;
  max-height: 20rem;
  object-fit: contain;
  background: #f6f4f0;
}

.question-evidence figcaption {
  overflow-wrap: anywhere;
  margin: 0.5rem 0;
}

.question-evidence .button {
  white-space: normal;
}

.question-manual {
  margin-top: 1rem;
}

.question-manual summary {
  cursor: pointer;
  padding: 0.75rem 0;
}

.photo-clarifications input[type=file] {
  max-width: 100%;
}

.photo-scope-note {
  padding: 0.75rem;
  background: #f6f4f0;
  font-size: 0.95rem;
}

/* 71-17: let the card and its controls wrap at their actual available width. */
.upload-panel, .photo-entry-form, .photo-attachments, .attachment-grid,
.attachment, .run-status, .run-task, .saved-reading, .connection {
  min-width: 0;
  max-width: 100%;
}

.attachment > *, .run-status > *, .saved-reading > * {
  min-width: 0;
  overflow-wrap: anywhere;
}

.photo-entry .attachment-actions {
  gap: 10px;
}

.upload-progress {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.upload-progress progress {
  flex: 1 1 8rem;
  min-width: 0;
  max-width: 100%;
}

@media (max-width: 420px) {
  .run-actions, .photo-entry .attachment-actions {
    flex-direction: column;
    align-items: stretch;
  }
  .photo-entry .attachment-actions > .button {
    flex: 0 1 auto;
    width: 100%;
  }
  .run-actions > .button {
    width: 100%;
  }
}`],
})
export class PageSajuComponent implements OnInit, OnDestroy {
    public access = new AccessSession();
    public loginOpen = false;
    private helpReturnFocus: HTMLElement | null = null;
    private noticeTimers: Array<ReturnType<typeof setTimeout>> = [];
    async showLogin() {
        this.loginOpen = true; await this.refresh(); this.focusInput('account-name');
    }
    choosePhoto() { document.getElementById('capture-files')?.click(); }
    openHelp(event: Event) {
        this.helpReturnFocus = event.currentTarget as HTMLElement;
        this.focusInput('service-help', event);
    }
    closeDetails(id: string, returnId: string) {
        const details = document.getElementById(id) as HTMLDetailsElement;
        if (details) details.open = false;
        if (id === 'photo-data-details') { this.photoPolicyOpen = false; this.refresh(); }
        this.focusInput(returnId);
    }
    closeHelp() {
        const details = document.getElementById('service-help') as HTMLDetailsElement;
        if (details) details.open = false;
        (this.helpReturnFocus?.isConnected ? this.helpReturnFocus : document.getElementById('help-link'))?.focus();
    }
    closeAccount(event: Event) {
        const details = event.currentTarget as HTMLDetailsElement;
        details.open = false; details.querySelector('summary')?.focus();
    }
    private clearActionNotice(session: { message: string }) {
        const message = session.message;
        if (!message) return;
        this.noticeTimers.push(setTimeout(() => {
            if (session.message === message) { session.message = ''; void this.refresh(); }
        }, 5000));
    }
    public deployment = new DeploymentCheck();
    public pwa = new PwaSession();
    private sessionChannel?: BroadcastChannel;
    private restoredPrivatePage = (event: PageTransitionEvent) => { if (event.persisted) { this.clearPrivateSession(); void this.restoreAccess(); } };
    private async reconnect() {
        // GET only: resume observing the same durable ID, never replay a command.
        if (!this.intake.connected) return;
        const token = this.intake.token;
        await this.verifySession();
        if (!this.intake.connected || token !== this.intake.token) return;
        if (this.page === 'run' || this.page === 'library') { await this.runs.poll(); await this.reading.load(false); }
        await this.refresh();
    }
    private sessionTimer?: ReturnType<typeof setInterval>;
    private sessionChecking = false;
    private leavingPrivatePage = () => { this.clearPrivateSession('', false); this.ref.detectChanges(); };
    private focusPrivatePage = () => { void this.verifySession(); };
    private clearPrivateSession(nextToken = '', forgetBuffers = true) {
        clearTimeout(this.photoSaveTimer); this.photoEditVersion = 0; this.photoSavedVersion = 0; this.photoDraftStatus = '';
        this.routeSerial++; this.loadingProfile = false; this.lastRunSelection = null;
        this.intake.token = nextToken; this.intake.connected = false; this.intake.list = []; this.intake.reset();
        this.uploads.disconnect(); this.runs.observe('', '', () => {});
        void this.questions.configure(null, ''); this.featureInput.clear(true);
        this.photoQuestions.clear();
        this.reader.reset('disconnected'); this.reading.route('', '', () => {}, this.reader);
        this.revisions = []; this.versionImpact = null; this.reviewEdits = {}; this.reviewEditImages = {}; this.reviewErrors = {}; this.reviewAttempted = false; this.reviewHelp = {}; this.reviewZoom = {}; this.reviewTextMessage = ''; this.characterOpen = {};
        this.deleteTarget = null; this.deleteMessage = ''; this.retryAcknowledged = {};
        try {
            if (forgetBuffers) for (const key of Object.keys(sessionStorage)) if (key.startsWith('saju.question.') || key.startsWith('saju.reading.') || key.startsWith('saju-export:') || key === 'saju-run-command') sessionStorage.removeItem(key);
        } catch {}
        this.savedQuestion = ''; this.reviewReason = '원본과 후보를 비교하여 확인';
    }
    private unauthorized = (token: string) => {
        if (token !== this.intake.token) return;
        this.sessionChannel?.postMessage('clear');
        this.clearPrivateSession();
        if (this.intake.local) this.intake.message = '인증이 만료되었거나 해제되었습니다. 다시 연결해 주세요.';
        else this.access.expired();
        void this.refresh();
    };
    async disconnect() { this.sessionChannel?.postMessage('clear'); this.clearPrivateSession(); await this.refresh(); }
    private async verifySession() {
        if (!navigator.onLine || !this.intake.connected || this.sessionChecking) return;
        this.sessionChecking = true;
        try { await this.intake.request('/session'); } catch { /* Auth rejection clears all private state via the callback. */ }
        finally { this.sessionChecking = false; }
    }
    public deleteTarget: any = null;
    public deleting = false;
    private deletionReturnFocus: HTMLElement | null = null;
    public deleteMessage = '';
    public stateOptions = Object.keys(RUN_STATES);
    async libraryFilter(key: string, event: Event) {
        await this.router.navigate(['/saju/library'], { queryParams: { ...this.runs.filters, [key]: (event.target as HTMLInputElement).value, offset: '0' } });
    }
    async libraryPage(delta: number) {
        await this.router.navigate(['/saju/library'], { queryParams: { ...this.runs.filters, offset: String(Math.max(0, Number(this.runs.filters.offset) + delta)) } });
    }
    async confirmDeletion(kind: string, item: any) {
        this.deletionReturnFocus = document.activeElement as HTMLElement;
        this.deleteMessage = '';
        this.deleteTarget = { kind, id: item.id, label: kind === 'profile' ? item.nickname :
            (item.current_nickname || item.nickname || item.input?.display_snapshot?.nickname || '') + ' · ' + this.featureName(item.feature_id || item.input?.feature_id || '') + ' · ' + this.savedDate(item.created_at) };
        await this.refresh(); this.element.nativeElement.querySelector('#delete-title')?.focus();
    }
    async cancelDeletion() {
        this.deleteTarget = null; await this.refresh();
        if (this.deletionReturnFocus?.isConnected) this.deletionReturnFocus.focus();
        else this.element.nativeElement.querySelector('h1')?.focus();
        this.deletionReturnFocus = null;
    }
    async deleteConfirmed(target = this.deleteTarget) {
        if (this.deleting || !target) return;
        if (!navigator.onLine) { this.deleteMessage = '현재 오프라인입니다. 연결 후 삭제를 다시 눌러 주세요.'; await this.refresh(); return; }
        const token = this.intake.token;
        this.deleting = true; await this.refresh();
        try {
            const response = await fetch('/api/saju/' + (target.kind === 'profile' ? 'profiles/' : 'runs/') + target.id,
                { method: 'DELETE', cache: 'no-store', credentials: 'include', headers: { Authorization: 'Bearer ' + token } });
            const body = await response.json();
            if (token !== this.intake.token) return;
            if (!response.ok) throw new Error('delete');
            this.runs.stop(true); this.questions.forget(target.kind, target.id); this.reader.reset('deleted:' + target.id);
            this.reading.route('', '', () => { void this.refresh(); }, this.reader);
            this.characterOpen = {}; this.retryAcknowledged = {}; this.featureInput.clear(true);
            if (target.kind === 'profile') { this.intake.reset(); this.uploads.clear(); this.revisions = []; }
            this.deleteTarget = null;
            this.deleteMessage = body.data.cleanup_state === 'complete' ? '삭제를 완료했습니다.' : '접근을 차단했습니다. 파일 정리를 다시 시도할 수 있습니다.';
            await this.intake.connect(); await this.router.navigate(['/saju/library']); this.readRoute(false);
        } catch {
            if (token === this.intake.token) this.deleteMessage = '삭제 응답을 확인하지 못했습니다. 같은 삭제를 다시 눌러 확인해 주세요.';
        } finally { this.deleting = false; await this.refresh(); }
    }
    async retryDeletion(item: any) { await this.deleteConfirmed({ kind: item.target_kind, id: item.target_id }); }

    public characterOpen: Record<string, boolean> = {};
    async toggleCharacter(id: string, event: Event) {
        this.characterOpen[id] = (event.target as HTMLDetailsElement).open;
        await this.refresh();
    }
    async expandCharacter() {
        this.element.nativeElement.querySelectorAll('.f1-disclosure').forEach((el: HTMLDetailsElement) => {
            this.characterOpen[el.id] = true; el.open = true;
        });
        await this.refresh();
    }
    async collapseCharacter() {
        this.element.nativeElement.querySelectorAll('.f1-disclosure').forEach((el: HTMLDetailsElement) => {
            this.characterOpen[el.id] = false; el.open = false;
        });
        await this.refresh();
    }
    public questions = new QuestionSession();
    async editQuestion(key: string, event: Event) {
        const value = (event.target as HTMLInputElement).value;
        if (key === 'source') {
            this.questions.select(value);
            (event.target as HTMLSelectElement).value = this.questions.source?.id || '';
        }
        else if (['text','situation','scope'].includes(key)) this.questions[key] = value;
        await this.refresh();
    }
    async askSource(source: any) {
        this.questions.configure(this.runs.run, this.intake.token);
        this.questions.choose(source);
        await this.refresh(); this.reader.go('linked-questions');
    }
    async askAnchor(anchor: string) { await this.askSource(this.questions.byAnchor(anchor)); }
    async questionAction(action: string, turn?: any) {
        if (action === 'followup') { this.questions.reopen(turn); await this.refresh(); this.reader.go('linked-questions'); return; }
        const work = action === 'send' ? this.questions.send(this.runs) : this.questions.resume(this.runs);
        await this.refresh(); await work; await this.refresh();
    }
    questionScopeLabel() { return (this.runs.run?.questions?.future_chapters || []).map((s: string) => '제' + s.replace('chapter_', '') + '장').join(', '); }
    questionPath(task: any, path: string) { return task.question_sources?.find((s: any) => s.reference.path === path); }
    questionItem(item: any) { return this.runs.run?.question_sources?.find((s: any) => s.reference.stage_id === 'synthesis' && s.reference.item_id === item.id); }
    questionTurns() { return (this.runs.run?.questions?.turns || []).filter((t: any) => !this.questions.thread || t.thread_id === this.questions.thread); }
    public reader = new ReportReader();
    public reading = new ReadingSession();
    private savedQuestion = '';
    async saveParagraph(anchor: string) { await this.reading.toggle(anchor); await this.refresh(); }
    async openBookmark(record: any, ask = false) {
        if (record.unavailable) return;
        if (record.run_id === this.routeRun) {
            if (ask) await this.askAnchor(record.anchor);
            else await this.reading.resumeAnchor(record.anchor);
        } else await this.router.navigate(['/saju/runs/' + record.run_id], {
            fragment: ask ? undefined : record.anchor, queryParams: ask ? { ask: record.anchor } : {} });
    }
    public readingReference = readingReference;
    public tableBlock = tableBlock;
    trackReader(_index: number, value: any) { return value.id || value.reader_id || value.path; }
    async renderRun() {
        const input = this.runs.run?.input;
        if (this.page === 'run' && this.runs.run?.id === this.routeRun && input?.profile_id && input?.revision_id) {
            this.lastRunSelection = { profile: input.profile_id, revision: input.revision_id };
            this.intake.selected = null;
        }
        await this.photoQuestions.configure(this.runs.run, this.intake.token);
        if (this.runs.run?.execution_kind === 'preparation') { await this.refresh(); return; }
        this.questions.configure(this.runs.run, this.intake.token);
        const anchor = this.reader.capture();
        const id = this.routeRun;
        await this.refresh();
        if (id !== this.routeRun) return;
        this.reader.maintain(anchor); this.reading.configure(this.runs.run);
        if (this.savedQuestion && this.runs.run) {
            const source = this.questions.byAnchor(this.savedQuestion);
            if (source) { this.savedQuestion = ''; await this.askSource(source); }
        }
    }
    public runs = new RunSession();
    public photoQuestions = new PhotoQuestionSession();
    public supplementBusy = false;
    public supplementMessage = '';
    async answerPhoto(question: any, kind: string, value = '') {
        const action = kind === 'photo' ? { kind, question_id: question.id, image_id: value } :
            { kind, question_id: question.id, answer: value };
        const work = this.runs.answerPhoto(action); await this.refresh(); await work; await this.refresh();
    }
    async correctPhoto(question: any, key: string) {
        const value = (this.photoQuestions.edits[key] || '').trim();
        const work = this.runs.answerPhoto({ kind: 'manual', question_id: question.id, key, value });
        await this.refresh(); await work; await this.refresh();
    }
    async editPhotoCorrection(key: string, event: Event) { this.photoQuestions.edits[key] = (event.target as HTMLInputElement).value; await this.refresh(); }
    trackPhotoArea(_index: number, area: any) { return area.image_id + ':' + JSON.stringify(area.region); }
    async supplementPhoto(event?: Event) {
        if (this.supplementBusy || this.runs.busy) return;
        const input = event?.target as HTMLInputElement;
        const files = input?.files ? Array.from(input.files) : [];
        if (input) input.value = '';
        this.supplementBusy = true; this.supplementMessage = ''; await this.refresh();
        try {
            const draft = this.runs.run.preparation.draft_id;
            if (this.uploads.draftId !== draft) await this.uploads.open(draft);
            this.uploads.select(files);
            for (const item of this.uploads.items.filter(i => i.status !== 'uploaded')) await this.uploads.uploadOne(item);
            if (this.uploads.unsettled) { this.supplementMessage = '사진 전송을 마치지 못했어요. 아래에서 다시 보내 주세요.'; return; }
            await this.runs.poll();
            await this.runs.answerPhoto({ kind: 'supplement' });
        } catch { this.supplementMessage = '사진 전송을 확인하지 못했어요. 기존 사진은 보관되어 있어요.'; }
        finally { this.supplementBusy = false; await this.refresh(); }
    }
    public runStates = RUN_STATES;
    public progressStates = PROGRESS_STATES;
    public taskStates = { ...RUN_STATES, completed: '결과 저장 완료' };
    public taskMessage = taskMessage;
    public readingBlocks = readingBlocks;
    public routeRun = '';
    public returnRun = '';
    public retryAcknowledged: Record<string, boolean> = {};
    public reviewEdits: Record<string, any> = {};
    public reviewEditImages: Record<string, string[]> = {};
    public reviewErrors: Record<string, string> = {};
    public reviewAttempted = false;
    public reviewHelp: Record<string, boolean> = {};
    public reviewZoom: Record<string, number> = {};
    public reviewTextMessage = '';
    get reviewRows() { return (this.uploads.review?.rows || []).filter((r: any) => r.kind === 'natal'); }
    trackReview(index: number, row: any) { return row.key; }
    get extraReviewRows() { return (this.uploads.review?.rows || []).filter((r: any) => r.kind !== 'natal'); }
    reviewImages(row: any) {
        const ids = new Set(row.options.flatMap((o: any) => o.evidence.filter((e: any) => e.active).map((e: any) => e.image_id)));
        return this.uploads.items.filter(i => ids.has(i.id) || !ids.size);
    }
    reviewCandidates(row: any) { return row.options.filter((o: any) => o.active); }
    get reviewTextRows() { return this.intake.rows.filter(row => !!row.value || !!row.raw || row.options.length); }
    get reviewTextMissing() {
        return this.intake.rows.filter(row => row.key !== 'hour' && (!row.value || !row.resolved || !!this.intake.error(row)))
            .map(row => LABELS[row.key]);
    }
    get reviewTextReady() {
        return !!this.intake.original && this.intake.text === this.intake.original && !this.intake.parseError &&
            !this.intake.columns.length && !this.reviewTextMissing.length &&
            this.intake.rows.every(row => !row.value || row.resolved && !this.intake.error(row));
    }
    reviewLocation(row: any, image: any) {
        const evidence = row.options.flatMap((o: any) => o.evidence).find((e: any) => e.image_id === image.id);
        return row.label + ' · ' + (evidence?.source_refs?.[0]?.locator || '원본에서 이 칸을 찾아 확대해 주세요');
    }
    async reviewEnlarge(row: any) { this.reviewHelp[row.key] = true; await this.refresh(); }
    async zoomReview(key: string, event: Event) { this.reviewZoom[key] = Number((event.target as HTMLInputElement).value); await this.refresh(); }
    async focusReviewPixel(key: string, event: MouseEvent) {
        const image = event.target as HTMLImageElement, box = image.getBoundingClientRect();
        const x = (event.clientX - box.left) / box.width, y = (event.clientY - box.top) / box.height;
        this.reviewZoom[key] = 3; await this.refresh();
        const frame = image.parentElement!;
        frame.scrollLeft = x * image.clientWidth - frame.clientWidth / 2;
        frame.scrollTop = y * image.clientHeight - frame.clientHeight / 2;
    }
    timeReviewLabel(state: any) {
        if (!state) return '';
        const labels: any = { confirmed: '사진과 확인한 시간의 사주를 유지합니다. 숫자 출생 시각은 없어도 됩니다.', unknown: '실제 태어난 시간을 모름 · 시주 제외',
            missing: '시간의 사주 확인 전', absent: '사진의 원국 표에 시간 열이 없음 · 시주 제외',
            not_read: '시간 열을 아직 확인하지 못했습니다.', auto_usable: '사진의 시간 열을 읽고 검사했습니다. 숫자 출생 시각 없이도 사용할 수 있습니다.',
            unreadable: '사진에서 시간의 사주를 읽지 못함 · 시주 제외',
            conflicting: '사진마다 시간의 사주가 다름 · 확인 전까지 제외', unconfirmed: '시간의 사주 미확인 · 확인 전까지 제외', excluded: '시간의 사주 사용 제외' };
        return labels[state.hour_pillar] || '';
    }
    public reviewReason = '원본과 후보를 비교하여 확인';
    public reviewRoles = { ...IMAGE_ROLES, excluded: '이번 명식에서 제외', other_person: '다른 사람 자료' };
    public reviewRoleKeys = Object.keys(this.reviewRoles);
    public imageRoles = IMAGE_ROLES;
    public imageRoleKeys = Object.keys(IMAGE_ROLES);
    public inputLabels = LABELS;
    public positions = POSITIONS;
    public stems = STEMS;
    public branches = BRANCHES;
    public routeProfile = '';
    public routeRevision = '';
    public loadingProfile = false;
    public loadingDraft = false;
    private lastRunSelection: { profile: string; revision: string } | null = null;
    public revisions: any[] = [];
    public versionImpact: any = null;
    public readingInfoMessage = '';
    private routeSerial = 0;
    private unload = (event: BeforeUnloadEvent) => { if (this.photoEditVersion !== this.photoSavedVersion || this.photoDraftWork || this.intake.pending || this.uploads.unsettled || this.uploads.busy || this.featureInput.hasContent || this.questions.text || this.questions.situation || this.questions.pending) { event.preventDefault(); event.returnValue = ''; } };
    public features: Feature[] = [];
    public catalogMessage = '';
    public calculationPolicy: any = null;
    public calculationPolicyMessage = '';
    public async checkCalculationPolicy() {
        try {
            const response = await fetch('/api/saju/profiles/calculation-policy', { cache: 'no-store', credentials: 'omit' });
            if (!response.ok) throw new Error();
            this.calculationPolicy = (await response.json()).data;
            this.calculationPolicyMessage = '';
        } catch {
            this.calculationPolicy = null;
            this.calculationPolicyMessage = '지원 범위를 확인하지 못했습니다. 외부 캡처·직접 입력을 이용해 주세요.';
        }
        await this.refresh();
    }
    public featureInput = new FeatureInputs();
    get canAskQuestions() { return !['F1', 'F2', 'F3'].includes(this.runs.run?.input?.feature_id); }
    get canReviseReading() { return this.canAskQuestions || this.runs.run?.input?.input_policy === 'fixed-reading/1.0.0'; }
    public profiles = DEMO_PROFILES;
    public page = 'home';
    public feature: Feature = EMPTY_FEATURE;
    public intendedFeature = '';
    public photoMissing = false;
    public photoStarting = false;
    public photoDraftStatus = '';
    private photoUploadWork?: Promise<void>;
    private photoDraftWork?: Promise<void>;
    private photoSaveTimer?: ReturnType<typeof setTimeout>;
    private photoEditVersion = 0;
    private photoSavedVersion = 0;
    private draftNavigating = false;
    get canReviewPhoto() {
        return this.uploads.review && this.uploads.review.outcome !== 'blocked' &&
            !this.uploads.review.clarification?.questions?.length &&
            !this.uploads.review.service_errors?.length && !this.uploads.hasReadingServiceError;
    }
    private queueDraftSave() {
        if (!this.intake.connected || this.loadingDraft || this.loadingProfile || this.photoStarting || this.page !== 'register') return;
        this.photoEditVersion++;
        this.photoDraftStatus = '입력을 보관하고 있어요…';
        clearTimeout(this.photoSaveTimer);
        const context = this.uploads.contextId, token = this.intake.token;
        this.photoSaveTimer = setTimeout(() => {
            if (context === this.uploads.contextId && token === this.intake.token && this.intake.connected) void this.persistPhotoDraft();
        }, 350);
        void this.refresh();
    }
    private async persistPhotoDraft() {
        const context = this.uploads.contextId, input = this.draftInput(), version = this.photoEditVersion;
        const work = (async () => {
            if (this.photoUploadWork) await this.photoUploadWork;
            if (context !== this.uploads.contextId || !this.intake.connected) return;
            await this.uploads.saveInput(input);
            if (context === this.uploads.contextId && version === this.photoEditVersion) {
                this.photoSavedVersion = version;
                this.photoDraftStatus = '';
            }
        })();
        this.photoDraftWork = work;
        let saved = false;
        try { await work; saved = context === this.uploads.contextId && this.intake.connected; }
        catch { if (context === this.uploads.contextId && version === this.photoEditVersion) this.photoDraftStatus = '입력을 보관하지 못했어요. 내용은 유지됩니다. 연결을 확인한 뒤 다시 시도해 주세요.'; }
        finally { if (this.photoDraftWork === work) this.photoDraftWork = undefined; await this.refresh(); }
        if (saved) await this.pinDraftLocation(context);
        return saved;
    }
    private async flushDraft() {
        clearTimeout(this.photoSaveTimer);
        const context = this.uploads.contextId;
        if (this.photoUploadWork) await this.photoUploadWork;
        if (this.photoDraftWork) await this.photoDraftWork.catch(() => {});
        if (context !== this.uploads.contextId || !this.intake.connected) return false;
        if (this.uploads.unsettled) {
            this.photoDraftStatus = '사진 보관을 마치지 못했어요. 해당 사진을 다시 보내 주세요.';
            await this.refresh(); return false;
        }
        while (this.photoSavedVersion !== this.photoEditVersion) {
            if (!await this.persistPhotoDraft()) return false;
        }
        return true;
    }
    private async beforeDraftNavigation(url = '') {
        if (this.photoStarting) return /^\/saju\/runs\/[a-f0-9]{32}(?:\?|$)/.test(url);
        if (this.page !== 'register' || !this.intake.connected || this.loadingDraft) return true;
        this.draftNavigating = true;
        try { return await this.flushDraft(); }
        finally { this.draftNavigating = false; }
    }
    private async pinDraftLocation(context: string) {
        if (context === this.uploads.contextId && this.uploads.draftId && this.page === 'register' && !this.photoStarting && !this.draftNavigating)
            await this.router.navigate([], { queryParams: { draft: this.uploads.draftId, profile: null, revision: null }, queryParamsHandling: 'merge', replaceUrl: true });
    }
    async choosePhotoFeature(event: Event) {
        if (await this.router.navigate(['/saju/register'], { queryParams: { ...this.featureStartContext((event.target as HTMLSelectElement).value),
            ...(this.uploads.draftId ? { draft: this.uploads.draftId } : {}) } })) this.queueDraftSave();
    }
    async startPhotoRun() {
        if (this.photoStartDisabled) return;
        if (this.intake.selected && !this.intake.dirty && !this.uploads.items.length) {
            if (!await this.beforeDraftNavigation()) return;
            await this.continueSaved(); await this.refresh(); return;
        }
        this.photoStarting = true;
        const feature = this.intendedFeature;
        const context = this.uploads.contextId, input = this.draftInput(), token = this.intake.token;
        clearTimeout(this.photoSaveTimer);
        this.photoDraftStatus = this.uploads.unsettled ? '사진 업로드를 기다리고 있어요. 준비되면 같은 요청을 이어갑니다.' : '현재 사진의 저장을 확인하고 있어요…';
        await this.refresh();
        try {
            if (this.photoUploadWork) await this.photoUploadWork;
            if (this.photoDraftWork) await this.photoDraftWork.catch(() => {});
            if (context !== this.uploads.contextId || token !== this.intake.token) return;
            if (this.uploads.unsettled) throw new Error('사진 업로드를 마치지 못했어요. 사진을 다시 보내면 같은 입력으로 시작할 수 있습니다.');
            await this.applyPhotoEdits();
            input.reviewEdits = { ...this.reviewEdits };
            await this.uploads.saveInput(input);
            this.photoSavedVersion = this.photoEditVersion;
            if (context !== this.uploads.contextId || token !== this.intake.token) return;
            const id = await this.runs.start(feature, '', token,
                { draft_id: this.uploads.draftId, image_ids: this.uploads.items.map(i => i.id), draft_version: this.uploads.draft.version });
            if (id) { this.intake.dirty = false; await this.router.navigate(['/saju/runs/' + id]); }
        } catch (error: any) { this.runs.message = error.message || '사진 초안을 준비하지 못했습니다. 같은 사진으로 다시 시도해 주세요.'; }
        finally { this.photoStarting = false; this.photoDraftStatus = ''; await this.pinDraftLocation(context); await this.refresh(); }
    }
    get photoStartDisabled() {
        return this.photoStarting || this.runs.busy || this.startPending || !this.intendedFeature || !this.intake.connected ||
            (!this.uploads.items.length && !(this.intake.selected && !this.intake.dirty)) || this.uploads.items.some(item => item.status === 'failed');
    }
    get usageLimited() { return this.runs.run?.tasks?.some((task: any) => task.error_code === 'SUBSCRIPTION_LIMIT_REACHED') || this.runs.run?.preparation?.error_code === 'SUBSCRIPTION_LIMIT_REACHED'; }
    get hasSavedReading() { return this.runs.run?.tasks?.some((task: any) => !!task.result); }
    readSavedResult() {
        const target = document.querySelector('.saved-reading') as HTMLElement;
        if (target) { target.setAttribute('tabindex', '-1'); target.focus(); target.scrollIntoView({ block: 'start' }); }
    }
    public photoPolicyOpen = false;
    async openPhotoPolicy(event: Event) {
        event.preventDefault(); this.photoPolicyOpen = true; await this.refresh(); this.focusInput('photo-data-details');
    }
    get readingStatus() { return runPresentation(this.runs.run); }
    get readingStatusTitle() { return this.readingStatus.title; }
    async readingAction() {
        if (this.runs.busy) return;
        const status = this.readingStatus;
        if (!this.runs.connected || status.action === 'poll') await this.refreshRun();
        else if (status.action === 'recover') await this.runs.recoverLocal();
        else if (status.action === 'prepare-retry') await this.retryPreparation();
        else if (status.action === 'retry') await this.runCommand('retry', status.task);
        else if (status.action === 'resume') await this.runCommand('resume');
        else if (status.action === 'clarify') { this.focusInput('photo-clarifications'); return; }
        else if (status.action === 'input') {
            const run = this.runs.run;
            await this.router.navigate(['/saju/register'], { queryParams: {
                feature: run.input.feature_id, returnRun: run.id,
                ...(run.execution_kind === 'preparation' ? { draft: run.preparation.draft_id } : { profile: run.input.profile_id })
            } }); return;
        }
        this.focusInput('reading-state-detail');
    }
    async retryPreparation() { const work = this.runs.preparationRetry(); await this.refresh(); await work; await this.refresh(); }
    public connectionCheck = false;
    public missingKind = '화면';
    public announcement = '';
    private subscription?: Subscription;
    private focusTimer?: ReturnType<typeof setTimeout>;

    constructor(@Inject( Service) public service: Service,@Inject( ExplorationSession)  public session: ExplorationSession,@Inject( IntakeSession)  public intake: IntakeSession,@Inject( UploadSession)  public uploads: UploadSession,@Inject( Router)         private router: Router,@Inject( ChangeDetectorRef)  private ref: ChangeDetectorRef,@Inject( ElementRef)  private element: ElementRef) { }

    public async ngOnInit() {
        this.intake.changed = () => this.queueDraftSave();
        this.uploads.beforeNavigate = url => this.beforeDraftNavigation(url);
        await this.service.init(this.ref);
        void this.deployment.load().then(() => this.refresh());
        if ('BroadcastChannel' in window) {
            this.sessionChannel = new BroadcastChannel('saju-private-session');
            this.sessionChannel.onmessage = event => { if (event.data === 'clear') {
                this.clearPrivateSession(); if (!this.intake.local) this.access.expired(); void this.refresh();
            } };
        }
        void this.pwa.init(() => { this.runs.connectivity(); void this.refresh(); }, () => this.reconnect());
        for (const session of [this.intake, this.uploads, this.runs, this.reading]) session.onUnauthorized = this.unauthorized;
        this.uploads.changed = () => { void this.refresh(); };
        this.questions.changed = () => { void this.refresh(); };
        this.sessionTimer = setInterval(() => { void this.verifySession(); }, 15000);
        window.addEventListener('pagehide', this.leavingPrivatePage);
        window.addEventListener('pageshow', this.restoredPrivatePage);
        window.addEventListener('focus', this.focusPrivatePage);
        window.addEventListener('beforeunload', this.unload);
        await this.reloadFeatures();
        if (!this.intake.local) await this.restoreAccess();
        this.subscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) this.readRoute(true);
        });
    }

    public ngOnDestroy() {
        this.noticeTimers.forEach(timer => clearTimeout(timer));
        this.intake.changed = () => {}; this.uploads.beforeNavigate = async () => true; clearTimeout(this.photoSaveTimer);
        this.photoQuestions.clear();
        this.pwa.destroy(); this.sessionChannel?.close();
        clearInterval(this.sessionTimer);
        window.removeEventListener('pagehide', this.leavingPrivatePage);
        window.removeEventListener('pageshow', this.restoredPrivatePage);
        window.removeEventListener('focus', this.focusPrivatePage);
        for (const session of [this.intake, this.uploads, this.runs, this.reading]) session.onUnauthorized = () => {};
        this.uploads.changed = () => {};
        this.reading.destroy();
        this.runs.stop(true);
        this.routeSerial++; this.featureInput.clear(true);
        this.subscription?.unsubscribe();
        window.removeEventListener('beforeunload', this.unload);
        clearTimeout(this.focusTimer);
    }

    public async reloadFeatures() {
        this.catalogMessage = '';
        try { this.features = await loadFeatures(); }
        catch (error: any) { this.features = []; this.catalogMessage = error.message; }
        this.readRoute(false);
        await this.refresh();
    }
    private async connectAccount() {
        if (!this.access.authenticated || !this.access.clientBinding) return;
        this.clearPrivateSession(this.access.clientBinding);
        try {
            await this.intake.connect();
            if (!this.intake.connected) throw new Error();
            await this.uploads.connect(this.intake.token);
            this.readRoute(false);
        } catch {
            this.intake.connected = false;
            if (this.access.authenticated) this.access.message = '개인 저장 공간 연결을 확인하지 못했습니다. 잠시 뒤 다시 시도해 주세요.';
        }
        await this.refresh();
    }
    public async restoreAccess() {
        if (this.intake.local) return;
        if (await this.access.restore()) await this.connectAccount();
        else { this.clearPrivateSession(); this.readRoute(false); await this.refresh(); }
    }
    public async updateAccess(key: 'username' | 'password', event: Event) {
        this.access[key] = (event.target as HTMLInputElement).value;
        this.access.message = '';
        await this.refresh();
    }
    public async login() {
        if (await this.access.login()) {
            this.loginOpen = false; await this.connectAccount();
            this.element.nativeElement.querySelector('h1')?.focus();
        }
        await this.refresh();
    }
    public async logout() {
        await this.access.logout();
        this.sessionChannel?.postMessage('clear');
        this.clearPrivateSession();
        this.readRoute(false);
        await this.refresh();
        this.element.nativeElement.querySelector('#account-name, #show-login')?.focus();
    }
    public async retryAccountConnection() { await this.connectAccount(); }
    get additionalInputs() { return ['F1', 'F2', 'F3'].includes(this.feature.id) ? [] : this.feature.inputs.filter(i => i.source === 'run'); }
    get primaryFeatures() { return ['F1', 'F2', 'F3'].map(id => this.features.find(item => item.id === id)).filter(Boolean) as Feature[]; }
    featureName(item: Feature | string) {
        const id = typeof item === 'string' ? item : item.id;
        return PUBLIC_FEATURES[id]?.name || (typeof item === 'string' ? id : item.name);
    }
    featureSummary(item: Feature) { return PUBLIC_FEATURES[item.id]?.summary || item.description; }
    publicText(value: string) { return (value || '').replace(/\bF[123]\b/g, id => this.featureName(id)); }
    async loadReadingInfo(event: Event) {
        if (!(event.target as HTMLDetailsElement).open || !this.intake.selected) return;
        const selected = this.intake.selected;
        if (selected.revision.reading_summary) return;
        this.readingInfoMessage = '읽어낸 정보를 불러오고 있어요.';
        try {
            const summary = await this.intake.request('/' + selected.profile.id + '/revisions/' + selected.revision.id + '/reading-summary');
            if (this.intake.selected !== selected) return;
            selected.revision.reading_summary = summary; this.readingInfoMessage = '';
        } catch { this.readingInfoMessage = '정보를 불러오지 못했어요. 닫았다가 다시 열어 주세요. 저장한 사주로 풀이는 시작할 수 있습니다.'; }
        await this.refresh();
    }
    featureStartContext(id: string) { return { feature: id, ...(this.returnRun ? { returnRun: this.returnRun } : {}) }; }
    get startPending() { return this.loadingProfile || this.loadingDraft || !this.intake.local && (this.access.checking || this.access.busy); }
    get activeSelection() {
        const input = this.page === 'run' ? this.runs.run?.input : null;
        if (input?.profile_id && input?.revision_id) return { profile: input.profile_id, revision: input.revision_id };
        if (this.routeProfile) return { profile: this.routeProfile, revision: this.routeRevision || this.intake.selected?.revision.id };
        const selected = this.intake.selected;
        return selected ? { profile: selected.profile.id, revision: selected.revision.id } : this.lastRunSelection;
    }
    startPath(id: string) {
        const selected = this.activeSelection;
        return selected ? '/saju/profiles/' + selected.profile + (id ? '/features/' + id : '') : '/saju/register';
    }
    startContext(id: string) {
        const selected = this.activeSelection;
        return selected ? { revision: selected.revision } : {
            ...this.featureStartContext(id), ...(this.uploads.draftId ? { draft: this.uploads.draftId } : {})
        };
    }
    get startLabel() { return this.activeSelection ? '저장한 사주로 계속하기' : this.uploads.items.length ? '보관한 사진으로 계속하기' : '만세력 사진 올리기'; }
    get intendedFeatureName() { return this.featureName(this.intendedFeature); }
    inputQuestion(id: string) { return this.feature.questions.find(q => q.input_ref === id)?.label || ''; }
    featureInputLabel(item: any) { return item.id === 'concern' ? '더 알고 싶은 점이 있나요?' : item.label.replace(/\s*\(선택\)\s*$/, ''); }
    async editFeatureInput(id: string, event: Event) {
        this.featureInput.edit(id, (event.target as HTMLInputElement).value); await this.refresh();
    }
    async checkFeatureInput() {
        if (!this.intake.selected || this.loadingProfile || this.featureInput.busy) return;
        const work = this.featureInput.check(this.feature, this.intake.selected,
            body => this.intake.request('/feature-input', 'POST', body));
        await this.refresh(); await work; await this.refresh();
    }
    async clearFeatureInput() { this.featureInput.clear(); await this.refresh(); }

    get profile() {
        const selected = this.intake.selected;
        if (selected) return { id: selected.profile.id, name: selected.profile.nickname, confirmed: true,
            revision: '저장일 ' + this.savedDate(selected.revision.created_at),
            summary: this.positions.map(k => this.inputLabels[k] + ' ' + (selected.revision.document.facts.pillars[k].normalized || '미제공·제외')).join(' · '),
            limitation: '저장된 확정 명식입니다. 제공하지 않은 운표의 해석 범위는 제한됩니다.' };
        return this.routeProfile ? undefined : this.session.profile;
    }
    get savedReview() {
        const source = this.intake.saved?.document?.sources?.find((s: any) => s.id === 'review-decisions');
        if (!source) return null;
        try { const audit = JSON.parse(source.reference); return audit.format === 'saju-review-v1' ? audit : null; }
        catch { return null; }
    }
    savedDate(value: string) { return value ? new Date(value).toLocaleString('ko-KR') : '날짜 확인 중'; }
    get featureContext() { return this.activeSelection ? { revision: this.activeSelection.revision } : {}; }
    get featuresPath() { const id = this.activeSelection?.profile; return id ? '/saju/profiles/' + id : '/saju/features'; }
    versionPath(item: any) { return '/saju/profiles/' + item.id + (this.intendedFeature ? '/features/' + this.intendedFeature : ''); }
    async chooseVersion(event: Event) {
        await this.router.navigate([this.routeProfile ? '/saju/profiles/' + this.routeProfile + (this.page === 'feature' ? '/features/' + this.feature.id : '') : this.featuresPath],
            { queryParams: { revision: (event.target as HTMLSelectElement).value } });
    }
    featurePath(id: string) { const profileId = this.activeSelection?.profile; return profileId ? '/saju/profiles/' + profileId + '/features/' + id : '/saju/features/' + id; }
    get savedFeaturePath() { return '/saju/profiles/' + this.intake.profileId + (this.intendedFeature ? '/features/' + this.intendedFeature : ''); }
    async timingAction(action: string) {
        const pending = (this.intake.timing as any)[action]();
        await this.refresh(); await pending; await this.refresh();
    }
    async timingEdit(section: any, key: string, part: string, event: Event) {
        this.intake.timing.edit(section, key, part, (event.target as HTMLInputElement).value); await this.refresh();
    }
    async refresh() { await this.service.render(); }
    focusInput(id: string, event?: Event) {
        event?.preventDefault();
        const target = document.getElementById(id);
        if (!target) return;
        if (target instanceof HTMLDetailsElement) target.open = true;
        let parent = target.parentElement;
        while (parent) { if (parent instanceof HTMLDetailsElement) parent.open = true; parent = parent.parentElement; }
        target.focus(); target.scrollIntoView({ block: 'center' });
    }
    inputIssueTarget(issue: any) {
        const key = String(issue.path || '').match(/\/pillars\/(year|month|day|hour)/)?.[1];
        return key ? 'value-' + key : String(issue.path || '').includes('nickname') ? 'nickname' : 'input-issues';
    }
    trackInputIssue(_index: number, issue: any) { return issue.target; }
    get runAnnouncement() {
        const status = this.readingStatus;
        return [status.title, status.detail, this.runs.connected ? '' : this.runs.connection, this.runs.message].filter(Boolean).join(' ');
    }
    async clearLibraryFilters() { await this.router.navigate(['/saju/library']); }
    async updateInput(key: string, event: Event) {
        (this.intake as any)[key] = (event.target as HTMLInputElement).value;
        if (key === 'token') {
            if (this.intake.connected) this.sessionChannel?.postMessage('clear');
            this.clearPrivateSession(this.intake.token, this.intake.connected);
        }
        else { this.intake.touch(); if (key === 'source') this.intake.rows.forEach(r => r.confirmed = false); }
        await this.refresh();
    }
    async updateRow(row: any, key: string, event: Event) {
        row[key] = (event.target as HTMLInputElement).value; row.confirmed = false; this.intake.touch(); await this.refresh();
    }
    async mapColumn(index: number, event: Event) { this.intake.mapping[index] = (event.target as HTMLSelectElement).value; this.queueDraftSave(); await this.refresh(); }
    async editValue(row: any, event: Event) { this.intake.edit(row, (event.target as HTMLInputElement).value); await this.refresh(); }
    async selectPart(row: any, part: number, event: Event) {
        const value = (event.target as HTMLSelectElement).value;
        this.intake.edit(row, part === 0 ? value + (row.value[1] || '') : (row.value[0] || ' ') + value);
        await this.refresh();
    }
    async act(action: string) {
        if (action === 'save' && this.runs.busy) return;
        if (action === 'save') this.intake.imageSources = this.uploads.sources;
        const pending = (this.intake as any)[action]();
        await this.refresh(); await pending; await this.refresh();
        if (this.intake.status === 'success') this.clearActionNotice(this.intake);
        if (action === 'save' && this.intake.status === 'success') await this.continueSaved();
        if (action === 'connect' && this.intake.connected) {
            try { await this.uploads.connect(this.intake.token); } catch { this.uploads.message = '이미지 저장 연결을 확인하지 못했습니다. 다시 연결해 주세요.'; }
            this.readRoute(false);
            await this.refresh();
        }
    }
    async openSaved(id: string) {
        if (this.intake.pending || !await this.beforeDraftNavigation()) return;
        try {
            this.uploads.clear(); this.intake.reset(); this.reviewEdits = {}; this.reviewEditImages = {};
            await this.router.navigate(['/saju/register'], { queryParams: { ...this.context, profile: id } });
        } catch (e) { this.intake.fail(e); }
        await this.refresh();
    }
    async newInput() {
        if (!await this.beforeDraftNavigation()) return;
        clearTimeout(this.photoSaveTimer); this.photoEditVersion = this.photoSavedVersion = 0; this.photoDraftStatus = '';
        this.lastRunSelection = null;
        this.uploads.clear(); this.intake.reset(); this.reviewAttempted = false; this.reviewEdits = {}; this.reviewEditImages = {}; this.reviewErrors = {}; this.reviewHelp = {}; this.reviewZoom = {}; this.reviewTextMessage = '';
        await this.router.navigate(['/saju/register'], { queryParams: this.context });
        await this.refresh();
    }
    private async continueSaved() {
        const revision = this.intake.selected?.revision || this.intake.saved;
        if (revision?.state !== 'confirmed' || this.runs.busy) return;
        const feature = this.intendedFeature;
        if (!feature) {
            await this.router.navigate([this.savedFeaturePath], { queryParams: { revision: revision.id } });
            return;
        }
        const id = await this.runs.start(feature, revision.id, this.intake.token);
        if (id) { await this.router.navigate(['/saju/runs/' + id]); }
        else {
            const definition = this.features.find(item => item.id === feature);
            if (definition && this.intake.selected) {
                this.featureInput.bind(definition, this.intake.selected);
            }
            await this.router.navigate([this.startPath(feature)], { queryParams: this.startContext(feature) });
        }
    }
    async uploadAction(work: () => Promise<void>) {
        if (this.uploads.busy || this.intake.locked) return;
        let release!: () => void;
        this.photoUploadWork = new Promise<void>(resolve => { release = resolve; });
        this.uploads.busy = true; this.uploads.message = ''; await this.refresh();
        try {
            await work(); if (this.uploads.review && this.uploads.draftId) await this.uploads.loadReview();
            if (!this.uploads.items.some(item => item.error) && !this.uploads.comparison) this.clearActionNotice(this.uploads);
        }
        catch (e: any) { this.uploads.message = e.message || '처리를 확인하지 못했습니다. 같은 작업을 다시 시도해 주세요.'; }
        finally {
            this.uploads.busy = false;
            release(); this.photoUploadWork = undefined;
            if (JSON.stringify(this.intake.imageSources) !== JSON.stringify(this.uploads.sources)) this.intake.touch();
            this.intake.imageSources = this.uploads.sources; await this.refresh();
        }
    }
    async loadReview() { await this.uploadAction(async () => { await this.uploads.loadReview(); }); }
    async readImage(item: any, retry = false) { await this.uploadAction(async () => { await this.uploads.readImage(item, retry); }); }
    async parseReviewText() {
        this.intake.parse();
        this.reviewTextMessage = this.intake.parseError ? '' : this.intake.columns.length ?
            '열 라벨이 없어 순서를 정하지 않았습니다. 각 열의 실제 라벨을 선택해 주세요.' :
            '년·월·일·시간 라벨에 따라 후보를 만들었습니다. 아래 값이 원문과 같은지 확인해 주세요.';
        await this.refresh();
    }
    async mapReviewText() {
        this.intake.applyMapping();
        this.reviewTextMessage = this.intake.parseError ? '' : '선택한 실제 라벨에 따라 후보를 만들었습니다. 아래 값이 원문과 같은지 확인해 주세요.';
        await this.refresh();
    }
    async applyReviewText() {
        this.reviewTextMessage = '';
        if (!this.reviewTextReady) {
            this.reviewTextMessage = this.reviewTextMissing.length ? '더 준비할 것: ' + this.reviewTextMissing.join('·') + '의 두 글자와 실제 라벨' :
                '붙여넣은 글과 열 라벨을 먼저 확인해 주세요.';
            await this.refresh(); return;
        }
        await this.uploadAction(async () => {
            await this.uploads.saveInput(this.draftInput());
            await this.uploads.loadReview();
            for (const row of this.intake.rows.filter(item => !!item.value)) {
                const target = this.uploads.review?.rows.find((item: any) => item.key === 'natal.' + row.key);
                if (!target) throw new Error(LABELS[row.key] + ' 확인 칸을 찾을 수 없습니다. 초안을 다시 불러와 주세요.');
                await this.uploads.decide({ kind: 'field', key: target.key, mode: 'manual', value: row.value.trim(),
                    source_kind: 'text', reason: '붙여넣은 텍스트의 ' + LABELS[row.key] + ' 라벨과 값을 확인' });
                row.confirmed = true;
                delete this.reviewEdits[target.key];
            }
            this.reviewTextMessage = '붙여넣은 후보를 같은 확인표에 반영했습니다. 년·월·일과 필요한 시간 칸을 확인한 뒤 저장해 주세요.';
        });
    }
    photoEditValue(row: any) { return this.currentPhotoEdit(row.key) ? this.reviewEdits[row.key] : row.selected_value ?? ''; }
    private currentPhotoEdit(key: string) {
        return this.reviewEdits[key] !== undefined && (this.reviewEditImages[key] || []).every(id => this.uploads.items.some(item => item.id === id));
    }
    reviewEdit(key: string, event: Event) {
        this.reviewEdits[key] = (event.target as HTMLInputElement).value;
        this.reviewEditImages[key] = this.uploads.items.map(item => item.id);
        this.intake.touch();
    }
    async reviewDecision(action: any) {
        await this.uploadAction(async () => { await this.uploads.decide({ ...action, reason: this.reviewReason }); this.intake.touch(); });
    }
    async chooseReview(row: any, mode: string, option?: any) {
        let value: any = this.reviewEdits[row.key] ?? row.selected_value ?? '';
        this.reviewErrors[row.key] = '';
        if (mode === 'manual' && row.kind === 'natal' && !GANZHI.includes(value)) {
            this.reviewErrors[row.key] = '이 칸에는 생년월일 숫자가 아닌 사진의 두 글자(예: 甲子)가 필요합니다. 원본 확대·사진 교체로 먼저 확인해 주세요.';
            await this.refresh(); return;
        }
        if (!['natal', 'natal_detail'].includes(row.kind) && row.target !== 'ganzhi') value = Number(value);
        await this.reviewDecision({ kind: 'field', key: row.key, mode, value, option_id: option?.id,
            time_use: row.key === 'natal.hour' && !!this.uploads.review.state.unknown && ['manual', 'select'].includes(mode) });
        const saved = this.uploads.review?.rows.find((r: any) => r.key === row.key);
        if (!this.uploads.reviewConflict && saved?.resolved && saved.choice?.mode === mode &&
            (mode === 'manual' ? saved.selected_value === value : mode === 'select' ? saved.choice.option_id === option?.id : true)) {
            delete this.reviewEdits[row.key]; await this.refresh();
        }
    }
    async reviewFile(item: any, event: Event) {
        await this.reviewDecision({ kind: 'file', image_id: item.id, role: (event.target as HTMLSelectElement).value, checked: true });
    }
    async reviewUnknown(event: Event) { await this.reviewDecision({ kind: 'unknown', value: (event.target as HTMLInputElement).checked }); }
    async acceptReviewConflict() {
        if (this.uploads.reviewConflict) {
            this.uploads.review = this.uploads.reviewConflict; this.uploads.draft.version = this.uploads.review.version;
            this.uploads.reviewConflict = null; await this.refresh();
        }
    }
    async saveReview() {
        this.reviewAttempted = true;
        await this.refresh();
        const pendingEdit = this.uploads.review?.rows.find((r: any) => this.reviewEdits[r.key] !== undefined &&
            String(this.reviewEdits[r.key]) !== String(r.selected_value ?? ''));
        if (pendingEdit) {
            this.reviewErrors[pendingEdit.key] = '수정한 글자가 아직 확인되지 않았습니다. 이 칸의 수정 확인 버튼을 눌러 주세요.';
            await this.refresh(); this.focusInput('review-value-' + pendingEdit.key); return;
        }
        const required = this.reviewRows.find((r: any) => r.target !== 'hour' && (!r.resolved || !r.selected_value));
        if (required) { this.focusInput('review-' + required.key); return; }
        if (this.intake.timing.active || !this.uploads.review || this.uploads.review.outcome === 'blocked' || this.intake.locked) return;
        const body: any = { nickname: this.intake.nickname, document: this.uploads.review.document,
            state: 'confirmed', confirm: true, request_id: crypto.randomUUID(),
            review_binding: { draft_id: this.uploads.draftId, token: this.uploads.review.token } };
        if (this.intake.profileId) { body.base_revision_id = this.intake.baseId; body.base_updated_at = this.intake.baseUpdatedAt || undefined; }
        this.intake.pending = { path: this.intake.profileId ? '/' + this.intake.profileId : '', method: this.intake.profileId ? 'PUT' : 'POST', body };
        await this.act('save');
    }
    private draftInput() {
        this.intake.selectedFeature = this.intendedFeature;
        return { ...this.intake.draftInput(), reviewEdits: { ...this.reviewEdits }, reviewEditImages: { ...this.reviewEditImages } };
    }
    private async applyPhotoEdits() {
        const edits = Object.entries(this.reviewEdits).filter(([key]) => this.currentPhotoEdit(key));
        if (!edits.length) return;
        await this.uploads.loadReview();
        if (!this.canReviewPhoto) throw new Error('사진에서 확인이 필요한 부분이 있어요. 안내된 질문을 확인해 주세요.');
        for (const [key, value] of edits) {
            if (!this.reviewRows.some((row: any) => row.key === key) || !GANZHI.includes(String(value).trim())) {
                this.reviewErrors[key] = '원본의 두 글자를 확인해 주세요. 수정하지 않으려면 읽어낸 값으로 되돌려 주세요.';
                throw new Error(this.reviewErrors[key]);
            }
        }
        for (const [key, value] of edits) {
            const row = this.reviewRows.find((row: any) => row.key === key);
            if (String(value).trim() !== row.selected_value) {
                await this.uploads.decide({ kind: 'field', key, mode: 'manual', value: String(value).trim(),
                    reason: '읽어낸 정보에서 사용자가 수정', source_kind: 'photo', time_use: key === 'natal.hour' && !!this.uploads.review.state.unknown });
            }
            delete this.reviewEdits[key]; delete this.reviewErrors[key];
        }
    }
    async selectImages(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files?.length) return;
        this.uploads.select(input.files); input.value = '';
        this.intake.selected = null; this.lastRunSelection = null;
        this.intake.touch();
        const context = this.uploads.contextId;
        await this.uploadAction(async () => {
            await this.uploads.saveInput(this.draftInput());
            const selected = this.uploads.items.filter(i => i.status === 'selected');
            for (const item of selected) { await this.uploads.uploadOne(item); await this.refresh(); }
        });
        await this.pinDraftLocation(context);
    }
    async retryImage(item: any) { await this.uploadAction(async () => {
        if (!this.uploads.draft) await this.uploads.saveInput(this.draftInput());
        await this.uploads.uploadOne(item);
    }); }
    async replaceImage(item: any, event: Event) {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0]; input.value = '';
        if (!file) return;
        await this.uploadAction(async () => {
            const replacement = await this.uploads.replace(item, file);
            if (!this.uploads.draft) await this.uploads.saveInput(this.draftInput());
            await this.uploads.uploadOne(replacement);
        });
    }
    async removeImage(item: any) { await this.uploadAction(async () => { await this.uploads.remove(item); }); }
    async moveImage(item: any, delta: number) { await this.uploadAction(async () => {
        const items = [...this.uploads.items]; const index = items.indexOf(item);
        [items[index], items[index + delta]] = [items[index + delta], items[index]];
        await this.uploads.edit(items);
    }); }
    async roleImage(item: any, event: Event) {
        const select = event.target as HTMLSelectElement; const role = select.value; select.value = item.role;
        await this.uploadAction(async () => { await this.uploads.edit(this.uploads.items.map(i => i.id === item.id ? { ...i, role } : i)); });
    }
    async openDraft(id: string) {
        if (this.intake.pending || !await this.beforeDraftNavigation()) return;
        clearTimeout(this.photoSaveTimer); this.photoEditVersion = this.photoSavedVersion = 0; this.photoDraftStatus = '';
        this.uploads.clear(); this.intake.reset(); this.reviewEdits = {}; this.reviewEditImages = {};
        // Opening a saved draft restores its own feature and photos. An unrelated
        // feature used before entering the list must not override that selection.
        await this.router.navigate(['/saju/register'], { queryParams: { draft: id,
            ...(this.returnRun ? { returnRun: this.returnRun } : {}) } });
    }
    private async restorePhotoDraft(id: string, serial: number, selectedFeature = '') {
        if (this.uploads.draftId === id && !this.intake.selected && !this.lastRunSelection) return;
        if (this.intake.dirty || this.intake.pending || this.uploads.unsettled) {
            this.uploads.message = '작성 중인 내용의 보관을 마친 뒤 다른 사진을 열어 주세요.';
            return;
        }
        this.loadingDraft = true; this.uploads.busy = true;
        this.lastRunSelection = null;
        const feature = selectedFeature;
        try {
            const input = await this.uploads.open(id, () => serial === this.routeSerial && this.intake.connected);
            if (serial !== this.routeSerial || !this.intake.connected) return;
            this.intake.restoreDraft(input, this.uploads.items.length > 0);
            this.reviewEdits = Object.fromEntries(Object.entries(input.reviewEdits || {}).filter(([key, value]) =>
                /^natal\.(year|month|day|hour)$/.test(key) && typeof value === 'string'));
            this.reviewEditImages = Object.fromEntries(Object.keys(this.reviewEdits).map(key => [key,
                Array.isArray(input.reviewEditImages?.[key]) ? input.reviewEditImages[key].filter((id: any) => typeof id === 'string') : this.uploads.items.map(item => item.id)]));
            this.photoEditVersion = this.photoSavedVersion = 0; this.photoDraftStatus = '';
            this.intendedFeature = feature || this.intake.selectedFeature;
            this.intake.selectedFeature = this.intendedFeature;
            this.intake.imageSources = this.uploads.sources;
        } catch (error: any) {
            if (serial === this.routeSerial && !error.stale) this.uploads.message = error.message || '사진을 불러오지 못했어요. 내 만세력에서 다시 열어 주세요.';
        }
        finally { if (serial === this.routeSerial) { this.loadingDraft = false; this.uploads.busy = false; await this.refresh(); } }
    }
    async compareDraft() { this.uploads.acceptComparedBase(); this.queueDraftSave(); await this.refresh(); }
    async deleteDraft() {
        if (!await this.beforeDraftNavigation()) return;
        await this.uploadAction(async () => { await this.uploads.deleteDraft(); });
        clearTimeout(this.photoSaveTimer); this.intake.reset(); this.reviewEdits = {}; this.reviewEditImages = {};
        this.photoEditVersion = this.photoSavedVersion = 0; this.photoDraftStatus = '';
        await this.router.navigate(['/saju/register'], { queryParams: this.context });
    }
    trackImage(index: number, item: any) { return item.id; }
    async confirmRow(row: any, event: Event) { row.confirmed = (event.target as HTMLInputElement).checked; this.intake.touch(); await this.refresh(); }
    async changeUnknown(event: Event) { this.intake.unknown = (event.target as HTMLInputElement).checked; this.intake.touch(); await this.refresh(); }
    validGanzhi(value: string) { return GANZHI.includes(value.trim()); }
    async resolveTyped(row: any) { this.intake.resolve(row, row.value); await this.refresh(); }
    async resolve(row: any, event: Event) { this.intake.resolve(row, (event.target as HTMLSelectElement).value); await this.refresh(); }
    async composition(active: boolean) { this.intake.composing = active; await this.refresh(); }
    async fetchRouteProfile(id: string, revision: string, serial: number) {
        const token = this.intake.token;
        const current = () => serial === this.routeSerial && token === this.intake.token && id === this.routeProfile && revision === this.routeRevision;
        this.loadingProfile = true; await this.refresh();
        try {
            if (this.page === 'register') {
                if (this.intake.dirty || this.intake.pending) return;
                const data = await this.intake.request('/' + id);
                if (!current()) return;
                if (this.intake.dirty || this.intake.pending) return;
                this.intake.load(data);
            } else {
                const data = await this.intake.request('/' + id);
                if (!current()) return;
                const rev = revision ? await this.intake.request('/' + id + '/revisions/' + revision) : data.current_revision;
                if (!current()) return;
                const history = await this.intake.request('/' + id + '/revisions');
                const impact = rev && data.current_revision && rev.id !== data.current_revision.id ? await this.intake.request('/' + id + '/impact', 'POST',
                    { before_revision_id: rev.id, after_revision_id: data.current_revision.id }) : null;
                if (!current()) return;
                if (!rev || rev.state !== 'confirmed') throw { status: 422, message: '확정 저장된 버전이 필요합니다.' };
                if (rev.profile_id !== id || revision && rev.id !== revision || data.profile.id !== id) throw { status: 422, message: '명식 선택 기준이 일치하지 않습니다.' };
                this.intake.selected = { profile: data.profile, revision: rev };
                this.lastRunSelection = null;
                if (this.page === 'feature') this.featureInput.bind(this.feature, this.intake.selected);
                this.revisions = history.filter((r: any) => r.state === 'confirmed'); this.versionImpact = impact;
                if (!revision) await this.router.navigate([], { queryParams: { ...this.context, revision: rev.id }, queryParamsHandling: 'merge', replaceUrl: true });
            }
        } catch (e) { if (current()) { this.intake.selected = null; this.intake.fail(e); this.page = 'missing'; } }
        finally { if (current()) { this.loadingProfile = false; await this.refresh(); } }
    }
    get currentRunTasks() { return this.runs.run?.tasks.filter((t: any) => t.status === 'running') || []; }
    chapterTasks(chapter: any) { return this.runs.run?.tasks.filter((t: any) => t.stage_id === chapter.id) || []; }
    chapterFailures(chapter: any) { return this.chapterTasks(chapter).filter((t: any) => t.status === 'failed').length; }
    trackChapter(_index: number, chapter: any) { return this.routeRun + ':' + chapter.id; }
    get newRunPath() { const input = this.runs.run?.input; return input ? '/saju/profiles/' + input.profile_id + '/features/' + input.feature_id : '/saju/features'; }
    async startRun() {
        if (!this.intake.selected || !this.intake.connected || this.loadingProfile || this.runs.busy) return;
        const work = ['F1','F2','F3'].includes(this.feature.id)
            ? this.runs.start(this.feature.id, this.intake.selected.revision.id, this.intake.token)
            : this.runs.startPrepared(this.featureInput.prepared, this.intake.token);
        await this.refresh(); const id = await work; await this.refresh();
        if (id) { this.featureInput.clear(); await this.router.navigate(['/saju/runs/' + id]); }
    }
    async runCommand(action: string, task?: any) {
        const work = this.runs.command(action, task, !!this.retryAcknowledged[task?.current_attempt]);
        await this.refresh(); await work; await this.refresh();
        if (action === 'cancel') this.focusInput('reading-state-detail');
    }
    async progressRun(mode?: string, event?: Event) {
        // Display the server choice even when a concurrent worker makes this command conflict.
        if (event) (event.target as HTMLSelectElement).value = this.runs.run?.progression?.mode || 'automatic';
        const work = this.runs.progress(mode); await this.refresh(); await work; await this.refresh();
    }
    async editRunField(field: string, event: Event) {
        this.runs[field] = (event.target as HTMLInputElement).value; await this.refresh();
    }
    async prepareRawChange() {
        const work = this.runs.prepareRawChange(path => this.intake.request(path));
        await this.refresh(); await work; await this.refresh();
    }
    async amendRun(kind: string, chapter = 2) {
        const work = this.runs.amend(kind, chapter); await this.refresh(); const id = await work; await this.refresh();
        if (id) await this.router.navigate(['/saju/runs/' + id]);
    }
    async acknowledgeRetry(task: any, event: Event) { this.retryAcknowledged[task.current_attempt] = (event.target as HTMLInputElement).checked; await this.refresh(); }
    async refreshRun() { const work = this.runs.poll(); await this.refresh(); await work; await this.refresh(); }
    async cardAction(action: 'load' | 'prepare' | 'download') { const work = this.runs.card[action](); await this.refresh(); await work; await this.refresh(); }
    async editCard(key: string, event: Event) { this.runs.card.edit(key, event); await this.refresh(); }
    async exportReport(mode: 'new' | 'retry' | 'restore') { const work = this.runs.exportReport(mode); await this.refresh(); await work; await this.refresh(); }
    async downloadPrint(event: Event, kind: 'html' | 'pdf', open: boolean) { const work = this.runs.downloadPrint(event, kind, open); await this.refresh(); await work; await this.refresh(); }
    async restoreComparisonPrint() { const work = this.runs.preparePrint(true); await this.refresh(); await work; await this.refresh(); }
    async prepareComparisonPrint() { const work = this.runs.preparePrint(); await this.refresh(); await work; await this.refresh(); }

    get context() { return { ...(this.intendedFeature ? { feature: this.intendedFeature } : {}), ...(this.returnRun ? { returnRun: this.returnRun } : {}) }; }
    get requiresAuthentication() {
        return !this.intake.local && (['register', 'library', 'run'].includes(this.page) || !!this.routeProfile);
    }
    get entryPath() { return this.profile?.confirmed ? this.featuresPath : '/saju/register'; }
    get returnPath() {
        return this.intendedFeature ? '/saju/features/' + this.intendedFeature : '/saju/features';
    }
    get title() {
        const titles: Record<string, string> = {
            home: '만세력 사진으로 내 사주 풀이 시작하기', register: this.intendedFeature ? this.intendedFeatureName : '사진으로 풀이 시작하기',
            profiles: '내 만세력', features: '풀이 선택',
            feature: this.featureName(this.feature),
            run: '내 풀이',
            status: this.featureName(this.feature) + ' 시작 안내', library: '내 풀이',
            missing: this.missingKind + (['결과', '판독 자료'].includes(this.missingKind) ? '를' : '을') + ' 열 수 없습니다'
        };
        return titles[this.page];
    }

    private readRoute(moveFocus: boolean) {
        if (this.loadingDraft) { this.loadingDraft = false; this.uploads.busy = false; }
        this.photoQuestions.clear(); this.supplementMessage = '';
        const serial = ++this.routeSerial;
        this.runs.stop();
        this.featureInput.leave();
        this.loadingProfile = false; this.revisions = []; this.versionImpact = null;
        const tree = this.router.parseUrl(this.router.url);
        const path = '/' + (tree.root.children['primary']?.segments.map(s => s.path).join('/') || '');
        const requested = this.features.find(f => f.id === tree.queryParams['feature']);
        this.intendedFeature = requested?.id || this.intake.selectedFeature || '';
        this.photoMissing = tree.queryParams['photo'] === 'missing';
        this.connectionCheck = tree.queryParams['connection-check'] === '1';
        if (requested) this.intake.selectedFeature = requested.id;
        this.announcement = '';
        const pages: Record<string, string> = {
            '/': 'home', '/saju': 'home', '/saju/home': 'home', '/saju/register': 'register',
            '/saju/profiles': 'profiles', '/saju/features': 'features', '/saju/library': 'library'
        };
        this.page = pages[path] || 'missing';
        this.routeRun = path.match(/^\/saju\/runs\/([a-f0-9]{32})$/)?.[1] || '';
        this.returnRun = /^[a-f0-9]{32}$/.test(tree.queryParams['returnRun'] || '') ? tree.queryParams['returnRun'] : '';
        if (this.routeRun) this.page = 'run';
        const match = path.match(/^\/saju\/features\/([A-Za-z][A-Za-z0-9_-]{0,63})$/);
        const profileMatch = path.match(/^\/saju\/profiles\/([^/]+)(?:\/features\/([A-Za-z][A-Za-z0-9_-]{0,63}))?$/);
        if (match && this.features.some(f => f.id === match[1])) {
            this.feature = this.features.find(f => f.id === match[1])!;
            this.intendedFeature = this.feature.id;
            this.intake.selectedFeature = this.feature.id;
            this.page = 'feature';
        } else if (profileMatch && (!profileMatch[2] || this.features.some(f => f.id === profileMatch[2])) && (this.profile?.id === profileMatch[1] || /^[a-f0-9]{32}$/.test(profileMatch[1]))) {
            this.page = 'features';
            if (profileMatch[2]) {
                this.feature = this.features.find(f => f.id === profileMatch[2])!;
                this.intendedFeature = this.feature.id;
                this.intake.selectedFeature = this.feature.id;
                this.page = 'feature';
            }
        } else if (path === '/saju/runs/preview' && requested) {
            this.feature = requested;
            this.page = 'status';
        }
        this.missingKind = path.startsWith('/saju/results/') ? '결과'
            : path.startsWith('/saju/runs/') ? '생성 작업'
            : path.startsWith('/saju/profiles/') ? '프로필'
            : path.startsWith('/saju/intakes/') ? '판독 자료' : '화면';
        this.routeProfile = profileMatch && /^[a-f0-9]{32}$/.test(profileMatch[1]) ? profileMatch[1]
            : this.page === 'register' && /^[a-f0-9]{32}$/.test(tree.queryParams['profile'] || '') ? tree.queryParams['profile'] : '';
        this.routeRevision = /^[a-f0-9]{32}$/.test(tree.queryParams['revision'] || '') ? tree.queryParams['revision'] : '';
        const draftId = /^[a-f0-9]{32}$/.test(tree.queryParams['draft'] || '') ? tree.queryParams['draft'] : '';
        if (this.page === 'register' && draftId && !this.routeProfile && this.intake.connected) void this.restorePhotoDraft(draftId, serial, requested?.id || '');
        if (this.routeProfile && tree.queryParams['revision'] && !this.routeRevision) {
            this.intake.selected = null; this.page = 'missing'; this.routeProfile = '';
            this.intake.status = 'error'; this.intake.message = '명식 버전 주소를 확인해 주세요.';
        }
        if (this.routeProfile && this.intake.connected) {
            if (this.page === 'register' && this.intake.profileId !== this.routeProfile) {
                this.intake.selected = null;
                if (this.intake.dirty || this.intake.pending) {
                    this.page = 'missing'; this.intake.message = '작성 중인 명식을 저장하거나 정리한 뒤 다른 프로필을 열어 주세요.';
                } else this.intake.reset();
            }
            if (this.page !== 'register') this.intake.selected = null;
            if (this.page !== 'missing' && (this.page !== 'register' || this.intake.profileId !== this.routeProfile)) void this.fetchRouteProfile(this.routeProfile, this.routeRevision, serial);
        }
        else if (this.routeProfile && this.page !== 'register') this.intake.selected = null;
        if (this.page === 'feature' && !this.routeProfile && this.intake.selected) this.featureInput.bind(this.feature, this.intake.selected);
        if (this.page === 'profiles' && this.intake.connected) void this.intake.connect().then(() => this.refresh());
        this.reader.reset(this.routeRun + ':' + this.intake.token);
        this.savedQuestion = tree.queryParams['ask'] || '';
        this.reading.route(this.routeRun, ['run','library'].includes(this.page) && this.intake.connected ? this.intake.token : '', () => { void this.refresh(); }, this.reader);
        if (this.page === 'library') {
            for (const key of Object.keys(this.runs.filters)) this.runs.filters[key] = tree.queryParams[key] || (key === 'offset' ? '0' : '');
        }
        if (this.page === 'run' || this.page === 'library') this.runs.observe(this.routeRun, this.intake.connected ? this.intake.token : '', () => { void this.renderRun(); });
        document.title = this.title + ' | 사주·캐해';
        this.ref.detectChanges();
        if (moveFocus) {
            clearTimeout(this.focusTimer);
            this.focusTimer = setTimeout(() => {
                this.element.nativeElement.querySelector('h1')?.focus();
            });
        }
    }

    public selectProfile(event: Event) {
        this.featureInput.leave(); this.routeSerial++; this.loadingProfile = false; this.lastRunSelection = null;
        this.intake.selected = null;
        this.session.select((event.target as HTMLSelectElement).value);
        // A profile-scoped URL must never silently display another profile.
        if (this.router.url.startsWith('/saju/profiles/')) {
            void this.router.navigate(['/saju/profiles'], { queryParams: this.context });
        }
        this.announcement = this.profile ? this.profile.name + '를 선택했습니다. 실제 저장 자료가 아닌 예시입니다.' : '예시 선택을 해제했습니다.';
        this.ref.detectChanges();
    }

    public useExample(id: string) {
        this.featureInput.leave(); this.routeSerial++; this.loadingProfile = false; this.lastRunSelection = null;
        this.intake.selected = null;
        this.session.select(id);
        void this.router.navigate([this.profile?.confirmed ? this.returnPath : '/saju/register'], { queryParams: this.context });
    }

    public skipToContent(event: Event) {
        event.preventDefault();
        this.element.nativeElement.querySelector('h1')?.focus();
    }
}

export default PageSajuComponent;